// extracted by mini-css-extract-plugin
export default {"container":"gbXz","notifyWrapper":"tDgG","notifyWrapperAttached":"wdae","notifyWrapperNotAttached":"f72q","notifyWrapperLaterAttached":"Tw7M"};